import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Loader2, Send } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (s) => (s ? new Date(s).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "noch nie");

export function EmailStatusAdmin() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/email/status").then((r) => setS(r.data));
  useEffect(() => { load(); }, []);
  const test = async () => {
    setBusy(true);
    try { setS((await api.post("/admin/email/test")).data); toast.success("Testmail verschickt"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Versand fehlgeschlagen"); load(); }
    setBusy(false);
  };
  const catchup = async () => {
    try { await api.post("/admin/email/welcome-catchup"); toast.success("Nachversand gestartet"); setTimeout(load, 4000); } catch { toast.error("Fehler"); }
  };
  if (!s) return <Loader2 className="w-5 h-5 animate-spin text-pink-500" />;
  const known = s.last_ok !== undefined;
  const ok = s.last_ok === true;
  return (
    <div className="space-y-4 max-w-xl" data-testid="admin-email-status">
      <div className={`lux-card rounded-3xl p-5 flex items-start gap-3 ${known ? (ok ? "border-emerald-200" : "border-red-200") : ""}`}>
        {ok ? <CheckCircle2 className="w-7 h-7 text-emerald-500 shrink-0" /> : <XCircle className={`w-7 h-7 shrink-0 ${known ? "text-red-500" : "text-slate-300"}`} />}
        <div className="min-w-0">
          <p className="font-bold" data-testid="admin-email-state">{!known ? "Noch kein Versuch gespeichert" : ok ? "E-Mail-Versand funktioniert" : "E-Mail-Versand gestört"}</p>
          {known && !ok && <p className="text-xs text-red-600 mt-1 break-words" data-testid="admin-email-error">Fehler {s.last_status}: {s.last_error}</p>}
          <p className="text-sm text-slate-600 mt-2" data-testid="admin-email-last-success">Letzte erfolgreiche Mail: <b>{fmt(s.last_success_at)}</b>{s.last_success_subject ? ` – „${s.last_success_subject}“` : ""}</p>
          <p className="text-sm text-slate-600" data-testid="admin-email-last-attempt">Letzter Versuch: {fmt(s.last_attempt_at)}</p>
          <p className="text-xs text-slate-500 mt-1" data-testid="admin-email-counts">Erfolgreich: {s.sent || 0} · Fehlgeschlagen: {s.failed || 0}</p>
        </div>
      </div>
      <button onClick={test} disabled={busy} data-testid="admin-email-test-btn" className="tap h-11 px-5 rounded-full pink-gradient text-white text-sm font-bold inline-flex items-center gap-2 disabled:opacity-60">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Testmail an {s.test_to} senden
      </button>
      <div className="lux-card rounded-3xl p-5 space-y-2" data-testid="admin-email-welcome">
        <p className="font-bold">Verpasste Willkommens-Mails</p>
        <p className="text-sm text-slate-600" data-testid="admin-email-welcome-pending">{s.welcome_running ? "Wird gerade nachgesendet … " : ""}Noch offen: <b>{s.welcome_pending}</b> Mitglieder. Sie werden automatisch nachgeschickt, sobald der Versand wieder klappt.</p>
        {s.welcome_pending > 0 && <button onClick={catchup} data-testid="admin-email-welcome-btn" className="tap h-10 px-5 rounded-full border border-pink-200 text-sm font-bold text-pink-600">Jetzt nachsenden</button>}
      </div>
    </div>
  );
}
